import { render, staticRenderFns } from "./AffectedModal.vue?vue&type=template&id=36b5f0bf&scoped=true&"
import script from "./AffectedModal.vue?vue&type=script&lang=js&"
export * from "./AffectedModal.vue?vue&type=script&lang=js&"
import style0 from "./AffectedModal.vue?vue&type=style&index=0&id=36b5f0bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5f0bf",
  null
  
)

export default component.exports